// extracted by mini-css-extract-plugin
export default {"widget":"Widget_widget__Vq+sR","title":"Widget_title__TY3iD"};